import { render, staticRenderFns } from "./ConvenioVouchers.vue?vue&type=template&id=4c3a254c&scoped=true"
import script from "./ConvenioVouchers.vue?vue&type=script&lang=js"
export * from "./ConvenioVouchers.vue?vue&type=script&lang=js"
import style0 from "./ConvenioVouchers.vue?vue&type=style&index=0&id=4c3a254c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a254c",
  null
  
)

export default component.exports